import { DataSourceEntityModel } from "src/store/models/entity/dataSource/entity";
import { DataSourceHelperModel } from "src/store/models/entity/dataSource/helper";
import { DataSourceListModel } from "src/store/models/entity/dataSource/list";

export const encooDataSourceModels = {
  entity: DataSourceEntityModel,
  list: DataSourceListModel,
  helper: DataSourceHelperModel,
};
